<template>
  <div class="layout">
    <JobseekerHeader :item="item" />
    <JobseekerSidebar :item="item" />
    <div class="layout_content">
      <div class="layout_content_title" v-if="personal">My Bio-Data</div>
      <div class="layout_content_title" v-if="documents">My Credentials</div>
      <div class="layout_content_title" v-if="submission">Make Payment</div>
      <div class="layout_content_title" v-if="payment">Payment Status</div>
      <div class="layout_content_nav">
        <div class="layout_content_nav_avatar">
          <div>
            <img
              src="../../../assets/images/boy.svg"
              alt="avatar"
              v-if="!passport"
            />
            <img :src="passport" alt="avatar" v-if="passport" />
          </div>
        </div>
        <div class="layout_content_nav_details">
          <p>
            {{ firstname }} {{ lastname }}
            <img
              src="../../../assets/images/checkmark.svg"
              alt="check"
              v-if="payment"
            />
          </p>

          <div>
            <div
              v-bind:style="[
                personal
                  ? { borderBottom: '5px solid #5099de' }
                  : { borderBottom: '5px solid  transparent' }
              ]"
              @click="openPersonal"
            >
              Bio-Data
            </div>

            <div
              v-bind:style="[
                documents
                  ? { borderBottom: '5px solid  #5099de' }
                  : { borderBottom: '5px solid  transparent' }
              ]"
              @click="openDocument"
            >
              Credentials
            </div>


          </div>
        </div>
      </div>
      <div class="layout_content_body">
        <div v-if="personal">
          <Personal @clickedDocument="openDocument" />
        </div>
        <div v-if="documents">
          <Document @clickedSubmission="openSubmission" />
        </div>
 
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import JobseekerHeader from "../../partials/jobseekerheader";
import JobseekerSidebar from "../../partials/jobseekersidebar";
import Personal from "./profile/personal";
import Document from "./profile/document";
import Submission from "./profile/submission";

export default {
  name: "JobseekerProfile",
  components: {
    JobseekerHeader,
    JobseekerSidebar,
    Personal,
    Document,
    Submission
  },
  data() {
    return {
      item: "profile",
      personal: true,
      documents: false,
      submission: false,
      payment: false,
      firstname: "",
      lastname: "",
      passport: "",
      s3URL: types.S3_BUCKET_URL,
      paid: false,
      documentLength: 0
    };
  },
  methods: {
    openPersonal() {
      window.scroll(0, 0);
      this.personal = true;
      this.documents = false;
      this.submission = false;
      this.payment = false;
    },
    openDocument() {
      window.scroll(0, 0);
      this.personal = false;
      this.documents = true;
      this.submission = false;
      this.payment = false;
    },
    openSubmission() {
      window.scroll(0, 0);
      this.personal = false;
      this.documents = false;
      this.submission = true;
      this.payment = false;
    },
    openPay() {
      window.scroll(0, 0);
      this.personal = false;
      this.documents = false;
      this.submission = false;
      this.payment = true;
    },
    getUserDetails() {
      this.firstname = this.$store.getters.currentAuthUser.firstname;
      this.lastname = this.$store.getters.currentAuthUser.lastname;

      if (this.$store.getters.currentAuthUser.jobseekers) {
        if (this.$store.getters.currentAuthUser.jobseekers.is_paid === 1) {
          this.paid = true;
        }
      }

      this.documentLength = this.$store.state.jobseekerDocumentLength;

      if (this.$store.state.jobseekerPassport) {
        this.passport = `${this.s3URL}/${this.$store.state.jobseekerPassport}`;
      }
    }
  },
  created() {
    this.getUserDetails();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  background-color: #fbfafa;
  min-height: 1000px;

  > .layout_content {
    padding-top: 120px;
    padding-left: 250px;
    padding-right: 50px;

    @media (max-width: 1000px) {
      padding-left: 10px;
      padding-right: 10px;
    }

    > .layout_content_title {
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      text-align: left;
      color: #f79320;
    }

    > .layout_content_nav {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      margin-top: 30px;

      > .layout_content_nav_avatar {
        width: 120px;

        @media (max-width: 800px) {
          width: 100%;
          text-align: center;
        }

        > div {
          width: 100px;
          height: 100px;
          background-color: #e6e6e6;
          border-radius: 100%;
          font-size: 13px;
          font-weight: 200;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: normal;
          text-align: center;
          color: #707070;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          overflow: hidden;
          margin: 0;

          @media (max-width: 800px) {
            margin: auto;
          }

          > img {
            width: 90%;
          }
        }

        > span {
          font-size: 10px;
          font-stretch: normal;
          font-style: italic;
          text-align: left;
        }
      }

      > .layout_content_nav_details {
        width: calc(100% - 120px);
        padding-left: 20px;

        @media (max-width: 800px) {
          width: 100%;
        }

        > p {
          font-size: 20px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.18;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          padding-top: 0;

          @media (max-width: 800px) {
            text-align: center;
            padding-top: 20px;
          }

          > img {
            width: 20px;
          }
        }

        > div {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          align-content: center;
          border-bottom: 1px solid #ccc;

          > div {
            width: 150px;
            padding: 10px 0;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
            border-bottom: 5px solid #5099de;
            cursor: pointer;

            @media (max-width: 800px) {
              width: 100%;
              text-align: left;
            }
          }
        }
      }
    }

    > .layout_content_body {
      margin-top: 40px;
      padding-bottom: 100px;
    }
  }
}
</style>
